import { ChildContractStatus } from 'types';

export const contractValidFilterValueMapper: Record<ChildContractStatus, boolean> = {
    ACTIVE: true,
    INACTIVE: false,
};
